export default function initializeIssuesList() {
    document.querySelectorAll('.block-issues-list').forEach(function (block) {
        new IssuesList(block);
    });
}

class IssuesList {
    constructor(block) {
        this.block = block;
        this.select = block.querySelector('[data-issues-year-filter]');
        this.groups = block.querySelector('[data-issues-groups]');
        this.loader = block.querySelector('.block-issues-list__loader');
        this.apiBase = (window.wpApiSettings?.root || '/wp-json/') + 'venti/v1/issues/';

        this.init();
    }

    init() {
        if (!this.select) return;

        this.select.addEventListener('change', () => this.load(this.select.value));
    }

    load(year) {
        const params = new URLSearchParams();
        if (year) params.set('year', year);

        this.showLoader();

        fetch(this.apiBase + '?' + params.toString())
            .then((response) => response.json())
            .then((data) => this.render(data.results || []))
            .catch(() => {})
            .finally(() => this.hideLoader());
    }

    showLoader() {
        this.groups.style.opacity = '0.4';
        this.groups.style.pointerEvents = 'none';
        if (this.loader) this.loader.style.display = 'flex';
    }

    hideLoader() {
        this.groups.style.opacity = '1';
        this.groups.style.pointerEvents = '';
        if (this.loader) this.loader.style.display = 'none';
    }

    render(issues) {
        const groups = {};
        issues.forEach((issue) => {
            if (!groups[issue.year]) groups[issue.year] = [];
            groups[issue.year].push(issue);
        });

        const years = Object.keys(groups).sort((a, b) => b - a);

        if (!years.length) {
            this.groups.innerHTML = `<p class="block-issues-list__empty">Brak wydań spełniających wybrane kryteria.</p>`;
            return;
        }

        this.groups.innerHTML = years.map((year) => this.renderGroup(year, groups[year])).join('');
    }

    renderGroup(year, issues) {
        return `
            <div class="block-issues-list__group">
                <div class="block-issues-list__year-row">
                    <h2 class="block-issues-list__year">${year}</h2>
                </div>
                <div class="row block-issues-list__list">
                    ${issues.map((issue) => this.renderCard(issue)).join('')}
                </div>
            </div>`;
    }

    renderCard(issue) {
        const meta = (issue.issue_number || issue.issue_label)
            ? `<div class="block-issues-list__card-meta">
                    ${issue.issue_number ? `<span class="block-issues-list__card-number">${this.escHtml(issue.issue_number)}</span>` : ''}
                    ${issue.issue_label ? `<span class="block-issues-list__card-label">${this.escHtml(issue.issue_label)}</span>` : ''}
                </div>`
            : '';

        return `
            <div class="col-12 col-md-6 col-xl-3 mb-4">
                <a href="${issue.link}" class="block-issues-list__card">
                    ${issue.cover ? `<img src="${issue.cover}" alt="${this.escHtml(issue.title)}" loading="lazy"/>` : ''}
                    ${issue.date ? `<span class="block-issues-list__card-date">${this.escHtml(issue.date)}</span>` : ''}
                    ${issue.topic ? `<span class="block-issues-list__card-topic">${this.escHtml(issue.topic)}</span>` : ''}
                    ${meta}
                </a>
            </div>`;
    }

    escHtml(str) {
        const div = document.createElement('div');
        div.textContent = str || '';
        return div.innerHTML;
    }
}
